import { I18n } from 'i18n-js'
import type { Dict } from 'i18n-js'
import locales from './locales.json'

export const i18n = new I18n()
i18n.store(locales as Dict)
i18n.defaultLocale = 'fr'
i18n.enableFallback = true
i18n.locale = document.documentElement.lang
